export const PLAN_LEVELS = {
  FREE: 0,
  BASIC: 1,
  GROWTH: 2,
  PRO: 3
};

export const PLAN_MAPPING = {
  "GOLD": "BASIC",
  "DIMOND": "GROWTH",
  "PLATINUM": "PRO",
  "SILVER": "GROWTH",
  "BRONZE": "BASIC"
};

